// extracted by mini-css-extract-plugin
export default {"OverflowScroll":"FamilyMedicalHistory_OverflowScroll__cOEI1"};